import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import actionCreators from 'actions/creators';
import GLOBAL from 'jcolorglobal';
import classNames from "classnames";
import CupoyRouter from "components/commons/router/CupoyRouter";
import CupoySrefView from "components/commons/router/CupoySrefView";

class EditInvoiceView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            yearmonth: '',
            istarttag: '',
            invoicenumber: '',
            invoiceTime: undefined,
            orderid: '',
            mrscid: '',
            settleType: '2',
            buyerName: '',
            buyerCrn: '',
            buyerEmail: '',
            invoiceSendAddress: '',
            srcType: GLOBAL.SRCTYPE.JCOLOR,
            isDonate: false,
            loveCode: '',
            carrierType: '',
            carrierId1: '',
            carrierId2: '',
            isTriCopy: false,
            printMark: 'N',
            pdtlist: [
                {
                    pdtname: '',
                    pdtcount: 0,
                    pdtprice: 0,
                    pdtid: '',
                    isParamsErrorMap: {},
                }
            ],
            isLoading: false,
            errorMsg: '',
            isParamsError: false,
            isParamsErrorMap: {},
            fromState: undefined,
            isLoadingInfo: false,
            isInfoError: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {

        var stateHistory = CupoyRouter.getHistory();
        var fromState;

        if(stateHistory.length > 1) {

            for(var i = 0; i < stateHistory.length; i++) {
                var prev = stateHistory[stateHistory.length - i],
                    statename;

                if(prev) {
                    statename = prev.state.name;

                    if(statename === CupoyRouter.STATES.INVOICE_LIST) {
                        fromState = prev;
                        break;
                    }
                }
            }
        }

        this.setState({
            fromState: fromState,
        });

        this.init(this.props);
    }

    componentWillReceiveProps(nextProps) {

        this.init(nextProps);
    }

    init(props) {

        if (!props.match) {
            return;
        }

        const {
            yearmonth,
            istarttag,
            invoicenumber,
        } = props.match.params;

        if(yearmonth === this.state.yearmonth && istarttag === this.state.istarttag && invoicenumber === this.state.invoicenumber) {
            return;
        }

        this.setState({
            yearmonth: yearmonth,
            istarttag: istarttag,
            invoicenumber: invoicenumber,
            isLoadingInfo: true,
            isInfoError: false,
        }, () => {
            // get invoice from redux
            const invoice = props.invoices[istarttag + invoicenumber];

            if (!invoice) {
                // 沒經過list就進來，抓取發票資料
                this.props.invoiceActions.getInvoiceInfo({
                    yearmonth: yearmonth,
                    istarttag: istarttag,
                    invoicenumber: invoicenumber,
                }).then((result) => {
                    this.setState({
                        isLoadingInfo: false,
                    });
                    this.initInvoice();
                }, (error) => {
                    this.setState({
                        isLoadingInfo: false,
                        isInfoError: true,
                    });
                });
            } else {
                this.setState({
                    isLoadingInfo: false,
                });
                this.initInvoice();
            }
        })
    }

    initInvoice() {

        const {
            istarttag,
            invoicenumber,
        } = this.state;

        const invoice = this.props.invoices[istarttag + invoicenumber];

        if(!invoice) {
            this.setState({
                isInfoError: true,
            });
            return;
        }

        const {
            orderid,
            mrscid,
            detail,
            receipttime,
        } = invoice;
        
        const {
            pdtlist,
            buyerinfo,
            option,
            loveCode,
            carrierType,
            carrierId1,
            carrierId2,
            address: invoiceSendAddress,
            email: buyerEmail,
        } = detail;

        const {
            buyername: buyerName,
            buyercrn: buyerCrn,
        } = buyerinfo;
        
        var newPdtlist = [];

        for(var i = 0; i < pdtlist.length; i++) {
            var product = pdtlist[i];

            newPdtlist.push({
                pdtname: product.pdtname,
                pdtcount: product.pdtcount,
                pdtprice: product.pdtprice,
                pdtid: product.pdtid,
                isParamsErrorMap: {},
            })
        }

        this.setState({
            orderid: orderid,
            mrscid: mrscid,
            buyerName: buyerName,
            buyerCrn: buyerCrn !== GLOBAL.DEFAULT_BUYERCRN ? buyerCrn : '',
            buyerEmail: buyerEmail,
            invoiceSendAddress: invoiceSendAddress,
            isDonate: Number(option) === 2,
            loveCode: loveCode,
            carrierType: carrierType,
            carrierId1: carrierId1,
            carrierId2: carrierId2,
            isTriCopy: buyerCrn && buyerCrn !== GLOBAL.DEFAULT_BUYERCRN,
            printMark: Number(option) === 1 ? 'Y' : 'N',
            pdtlist: newPdtlist,
            invoiceTime: receipttime,
        });
    }

    onInputChange(fieldname, event) {

        this.setState({
            [fieldname]: event.target.value
        })
    }

    onPdtlistInputChange(index, fieldname, event) {

        const pdt = this.state.pdtlist[index];
        const newpdt = Object.assign({}, pdt, {
            [fieldname]: event.target.value
        });
        const newpdtlist = this.state.pdtlist;
        newpdtlist[index] = newpdt;

        this.setState({
            pdtlist: newpdtlist,
        });
    }

    expandPdtlist() {

        let newpdtlist = this.state.pdtlist;

        newpdtlist.push({
            pdtname: '',
            pdtcount: 0,
            pdtprice: 0,
            pdtid: '',
            isParamsErrorMap: {},
        });

        this.setState({
            pdtlist: newpdtlist
        });
    }

    removeProduct(index) {

        let newpdtlist = this.state.pdtlist;

        if(newpdtlist.length < 1) {
            return;
        }

        newpdtlist.splice(index , 1);

        this.setState({
            pdtlist: newpdtlist
        });
        
    }

    changeIsTriCpoy(isTriCopy) {

        this.setState({
            isTriCopy: isTriCopy,
        })
    }

    changeOption(isDonate, isPrintMark) {

        var carrierType = this.state.carrierType;

        if(isDonate && carrierType === GLOBAL.CARRIER_TYPE.MEMBER.value) {
            carrierType = '';
        } else if(!isDonate && !carrierType) {
            carrierType =  GLOBAL.CARRIER_TYPE.MEMBER.value;
        }

        this.setState({
            isDonate: isDonate,
            printMark: isPrintMark ? 'Y' : 'N',
            carrierType: carrierType,
        })
    }

    handleSubmit(event) {

        event.preventDefault();

        if (this.state.isLoading) {
            return;
        }

        const {
            yearmonth,
            istarttag,
            invoicenumber,
            buyerName,
            orderid,
            mrscid,
            srcType,
            invoiceSendAddress,
            isDonate,
            isTriCopy,
            loveCode,
            buyerCrn,
            printMark,
            carrierType,
            carrierId1,
            carrierId2,
            buyerEmail,
            pdtlist,
            invoiceTime,
        } = this.state;

        var isParamsError = false;
        var isParamsErrorMap = {};

        if(!buyerName) {
            isParamsErrorMap['buyerName'] = true;
            isParamsError = true;
        }

        if(!orderid) {
            isParamsErrorMap['orderid'] = true;
            isParamsError = true;
        }

        if(!mrscid) {
            isParamsErrorMap['mrscid'] = true;
            isParamsError = true;
        }
        
        if(!invoiceSendAddress) {
            isParamsErrorMap['invoiceSendAddress'] = true;
            isParamsError = true;
        }

        if(!buyerEmail) {
            isParamsErrorMap['buyerEmail'] = true;
            isParamsError = true;   
        }

        var salesAmount = 0; // 未稅總價

        for(var i = 0; i < pdtlist.length; i++) {
            var product = pdtlist[i];

            product.isParamsErrorMap = {};
            
            if(!product.pdtname) {
                product.isParamsErrorMap['pdtname'] = true;
                isParamsError = true;
            }
            if(!product.pdtid) {
                product.isParamsErrorMap['pdtid'] = true;
                isParamsError = true;
            }
            if(isNaN(product.pdtcount) || product.pdtcount < 1) {
                product.isParamsErrorMap['pdtcount'] = true;
                isParamsError = true;
            }
            if(isNaN(product.pdtprice)) {
                product.isParamsErrorMap['pdtprice'] = true;
                isParamsError = true;
            }
            if(!product.isParamsErrorMap['pdtcount'] && !product.isParamsErrorMap['pdtprice']) {
                salesAmount = salesAmount + product.pdtcount * product.pdtprice;
            } 
        }

        var payload = {
            yearmonth: yearmonth,
            istarttag: istarttag,
            invoiceNumber: invoicenumber,
            buyerName: buyerName,
            salesAmount: Math.round(salesAmount),
            orderid: orderid,
            mrscid: mrscid,
            srcType: srcType,
            invoiceSendAddress: invoiceSendAddress,
            buyerEmail: buyerEmail,
            pdtlist: pdtlist,
            invoiceTime: invoiceTime,
        };

        if(isTriCopy) {
            if(!buyerCrn || isNaN(buyerCrn) || buyerCrn.length !== 8) {
                isParamsErrorMap['buyerCrn'] = true;
                isParamsError = true;
            } else {
                payload.buyerCrn = buyerCrn;
            }

            payload.printMark = 'Y';
        } else {
            if (isDonate) {
                if(!loveCode) {
                    isParamsErrorMap['loveCode'] = true;
                    isParamsError = true;
                }

                payload.printMark = 'N';
                payload.isDonate = isDonate;
                payload.loveCode = loveCode;
                payload.carrierType = carrierType;
            } else {
                if(printMark === 'N') {

                    payload.carrierType = carrierType;

                    if(carrierType !== GLOBAL.CARRIER_TYPE.MEMBER.value) {

                        if(!carrierId1) {
                            isParamsErrorMap['carrierId1'] = true;
                            isParamsError = true;
                        }
                        if(!carrierId2) {
                            isParamsErrorMap['carrierId2'] = true;
                            isParamsError = true;
                        }

                        payload.carrierId1 = carrierId1;
                        payload.carrierId2 = carrierId2;
                    }                    
                }

                payload.printMark = printMark;
            }
        }

        if(isParamsError) {

            this.setState({
                pdtlist: pdtlist,
                isParamsError: isParamsError,
                isParamsErrorMap: isParamsErrorMap,
            })

            return;
        }

        this.setState({
            isLoading: true,
            errorMsg: '',
            pdtlist: pdtlist,
            isParamsError: isParamsError,
            isParamsErrorMap: isParamsErrorMap,
        }, () => {

            this.props.invoiceActions.updateInvoice(payload).then((result) => {
                if (result) {
                    // 重拉資料更新store
                    this.props.invoiceActions.getInvoiceInfo({
                        yearmonth: yearmonth,
                        istarttag: istarttag,
                        invoicenumber: invoicenumber,
                    }).then(() => {
                        this.props.webActions.cupoyStateGo(CupoyRouter.STATES.INVOICE_INFO, {
                            yearmonth: yearmonth,
                            istarttag: istarttag,
                            invoicenumber: invoicenumber,
                        });
                    }, () => {
                        this.props.webActions.cupoyStateGo(CupoyRouter.STATES.INVOICE_INFO, {
                            yearmonth: yearmonth,
                            istarttag: istarttag,
                            invoicenumber: invoicenumber,
                        });
                    })
                } else {
                    this.setState({
                        isLoading: false,
                        errorMsg: '發生無法處理的錯誤，請聯絡工程師',
                    });
                }

            }, (error) => {

                if (error && error.message) {
                    this.setState({
                        isLoading: false,
                        errorMsg: error.message,
                    });
                } else {
                    this.setState({
                        isLoading: false,
                        errorMsg: '發生無法處理的錯誤，請聯絡工程師',
                    });
                }
            });
        });
    }

    render() {

        const { 
            yearmonth,
            istarttag,
            invoicenumber,
            fromState,
            orderid,
            mrscid,
            buyerName,
            buyerEmail,
            invoiceSendAddress,
            isTriCopy,
            buyerCrn,
            isDonate,
            printMark,
            carrierType,
            carrierId1,
            carrierId2,
            loveCode,
            pdtlist,
            errorMsg,
            isLoading,
            isParamsError,
            isParamsErrorMap,
            isLoadingInfo,
            isInfoError,
        } = this.state;

        return (
            <div id="create-invoice">
                <div className="header-bar mix">
                    <ul className="bread-crumbs">
                        <li className="crumb-item">
                            {fromState ?
                                <CupoySrefView
                                    statename={fromState.state.name}
                                    params={fromState.params}
                                    querys={fromState.querys}
                                >
                                    開立發票列表
                                </CupoySrefView>
                                :
                                <CupoySrefView
                                    statename={CupoyRouter.STATES.INVOICE_LIST}
                                    params={{
                                        page: 1,
                                    }}
                                >
                                    開立發票列表
                                </CupoySrefView>
                            }
                        </li>
                        <div className="crumb-arrow"><i className="zmdi zmdi-chevron-right"></i></div>
                        <li className="crumb-item">
                            <CupoySrefView
                                statename={CupoyRouter.STATES.INVOICE_INFO}
                                params={{
                                    yearmonth: yearmonth,
                                    istarttag: istarttag,
                                    invoicenumber: invoicenumber,
                                }}
                            >
                                發票「{istarttag}-{invoicenumber}」
                            </CupoySrefView>
                        </li>
                        <div className="crumb-arrow"><i className="zmdi zmdi-chevron-right"></i></div>
                        <li className="crumb-item active">
                            <a>編輯</a>
                        </li>
                    </ul>
                    <div className="button-group">
                        {isParamsError ?
                            <span className="error">部分欄位有誤或未填寫</span>
                            :
                            null
                        }
                        {errorMsg ?
                            <span className="error">{errorMsg}</span>
                            :
                            null
                        }
                        <a className="button blue" onClick={this.handleSubmit}>
                            {isLoading
                                ?
                                <i className="zmdi zmdi-spinner animate-spinner"></i>
                                :
                                null
                            }
                            修改發票
                        </a>
                    </div>
                </div>

                {isLoadingInfo ?
                    <div className="form has-padding">
                        <div className="form-row">
                            <div className="form-col loading">
                                <i className="zmdi zmdi-spinner animate-spinner"></i>
                                <span>正在讀取訂單資訊</span>
                            </div>
                        </div>
                    </div>
                    :
                    null
                }

                {isInfoError ?
                    <div className="form has-padding">
                        <div className="form-row">
                            <div className="form-col loading">
                                發生錯誤，請再嘗試一次。
                            </div>
                        </div>
                    </div>
                    :
                    null
                }

                {!isLoadingInfo && !isInfoError ?
                    <div className="scroll-content">
                        <div className="form">
                            <div className="block-form">
                                <h3 className="block-title">發票資訊</h3>
                                <div className="block-form-row">
                                    <div className="block-form-col green">
                                        <h5 className="title">期別</h5>
                                        <div className="description">
                                            {yearmonth}
                                        </div>
                                    </div>
                                    <label 
                                        className={classNames("block-form-col", {
                                           'error': isParamsErrorMap['orderid']
                                        })}
                                    >
                                        <h5 className="title">
                                            訂單編號
                                            {isParamsErrorMap['orderid'] ? <span className="error-tip">請輸入訂單編號</span> : null}
                                        </h5>
                                        <input
                                            type="text"
                                            value={orderid}
                                            onChange={(event) => this.onInputChange('orderid', event)}
                                        />
                                    </label>
                                </div>
                                <div className="block-form-row">
                                    <label 
                                        className={classNames("block-form-col", {
                                           'error': isParamsErrorMap['mrscid']
                                        })}
                                    >
                                        <h5 className="title">
                                            會員編號
                                            {isParamsErrorMap['mrscid'] ? <span className="error-tip">請輸入會員編號</span> : null}
                                        </h5>
                                        <input
                                            type="text"
                                            value={mrscid}
                                            onChange={(event) => this.onInputChange('mrscid', event)}
                                        />
                                    </label>
                                    <label 
                                        className={classNames("block-form-col", {
                                           'error': isParamsErrorMap['buyerName']
                                        })}
                                    >
                                        <h5 className="title">
                                            買受人
                                            {isParamsErrorMap['buyerName'] ? <span className="error-tip">請輸入買受人</span> : null}
                                        </h5>
                                        <input
                                            type="text"
                                            value={buyerName}
                                            onChange={(event) => this.onInputChange('buyerName', event)}
                                        />
                                    </label>
                                </div>
                                <div className="block-form-row">
                                    <label 
                                        className={classNames("block-form-col", {
                                           'error': isParamsErrorMap['buyerEmail']
                                        })}
                                    >
                                        <h5 className="title">
                                            買受人EMail
                                            {isParamsErrorMap['buyerEmail'] ? <span className="error-tip">請輸入買受人EMail</span> : null}
                                        </h5>
                                        <input
                                            type="text"
                                            value={buyerEmail}
                                            onChange={(event) => this.onInputChange('buyerEmail', event)}
                                        />
                                    </label>
                                    <label 
                                        className={classNames("block-form-col", {
                                           'error': isParamsErrorMap['invoiceSendAddress']
                                        })}
                                    >
                                        <h5 className="title">
                                            發票寄送地址
                                            {isParamsErrorMap['invoiceSendAddress'] ? <span className="error-tip">請輸入發票寄送地址</span> : null}
                                        </h5>
                                        <input
                                            type="text"
                                            value={invoiceSendAddress}
                                            onChange={(event) => this.onInputChange('invoiceSendAddress', event)}
                                        />
                                    </label>
                                </div>
                            </div>   
                        </div>

                        <div 
                            className={classNames("block-form", {
                               'none-box-shadow': !isTriCopy
                            })}
                        >
                            <h3 className="block-title">發票種類與捐贈資訊</h3>
                            <p className="block-description">三聯式發票不得捐贈</p>
                            <div className="block-form-row">
                                <label 
                                    className={classNames("block-select-col pointer", {
                                       'blue': !isTriCopy
                                    })}
                                    onClick={() => this.changeIsTriCpoy(false)}
                                >
                                    <i className="zmdi zmdi-check"></i>
                                    二聯式發票
                                </label>
                                <label 
                                    className={classNames("block-select-col pointer", {
                                       'blue': isTriCopy
                                    })}
                                    onClick={() => this.changeIsTriCpoy(true)}
                                >
                                    <i className="zmdi zmdi-check"></i>
                                    三聯式發票
                                </label>
                            </div>
                            {isTriCopy ?
                                <div className="block-form-row">
                                    <label 
                                        className={classNames("block-form-col", {
                                           'error': isParamsErrorMap['buyerCrn']
                                        })}
                                    >
                                        <h5 className="title">
                                            買受人統編
                                            {isParamsErrorMap['buyerCrn'] ? <span className="error-tip">請輸入買受人統編或是正確的格式</span> : null}
                                        </h5>
                                        <input
                                            type="text"
                                            value={buyerCrn}
                                            onChange={(event) => this.onInputChange('buyerCrn', event)}
                                        />
                                    </label>
                                    <label className="block-form-col">
                                    </label>
                                </div>
                                :
                                null
                            }
                        </div>

                        {!isTriCopy ?
                            <div className="block-form">
                                <div className="block-form-row">
                                    <label 
                                        className={classNames("block-select-col pointer", {
                                           'blue': isDonate
                                        })}
                                        onClick={() => this.changeOption(true, false)}
                                    >
                                        <i className="zmdi zmdi-check"></i>
                                        捐贈
                                    </label>
                                    <label 
                                        className={classNames("block-select-col pointer", {
                                           'blue': !isDonate && printMark === 'N'
                                        })}
                                        onClick={() => this.changeOption(false, false)}
                                    >
                                        <i className="zmdi zmdi-check"></i>
                                        載具
                                    </label>
                                    <label 
                                        className={classNames("block-select-col pointer", {
                                           'blue': !isDonate && printMark === 'Y'
                                        })}
                                        onClick={() => this.changeOption(false, true)}
                                    >
                                        <i className="zmdi zmdi-check"></i>
                                        寄送
                                    </label>
                                </div>

                                {!isDonate && printMark === 'N' ?
                                    <div>
                                        <div className="block-form-row">
                                            <label className="block-form-col">
                                                <h5 className="title">載具種類編號</h5>
                                                <div className="form-select">
                                                    <select value={carrierType} onChange={(event) => this.onInputChange('carrierType', event)}>
                                                        <option value={GLOBAL.CARRIER_TYPE.MEMBER.value}>
                                                            {GLOBAL.CARRIER_TYPE.MEMBER.label}
                                                        </option>
                                                        <option value={GLOBAL.CARRIER_TYPE.CITIZEN_CERT.value}>
                                                            {GLOBAL.CARRIER_TYPE.CITIZEN_CERT.label}
                                                        </option>
                                                        <option value={GLOBAL.CARRIER_TYPE.MOBILE.value}>
                                                            {GLOBAL.CARRIER_TYPE.MOBILE.label}
                                                        </option>
                                                    </select>
                                                    <div className="select-arrow"><i className="zmdi zmdi-caret-down"></i></div>
                                                </div>
                                            </label>
                                        </div>
                                        {GLOBAL.CARRIER_TYPE.MEMBER.value === carrierType ?
                                            null
                                            :
                                            <div className="block-form-row">
                                                <label 
                                                    className={classNames("block-form-col", {
                                                       'error': isParamsErrorMap['carrierId1']
                                                    })}
                                                >
                                                    <h5 className="title">
                                                        載具明碼
                                                        {isParamsErrorMap['carrierId1'] ? <span className="error-tip">請輸入載具明碼</span> : null}
                                                    </h5>
                                                    <input
                                                        type="text"
                                                        value={carrierId1}
                                                        onChange={(event) => this.onInputChange('carrierId1', event)}
                                                    />
                                                </label>
                                                <label 
                                                    className={classNames("block-form-col", {
                                                       'error': isParamsErrorMap['carrierId2']
                                                    })}
                                                >
                                                    <h5 className="title">
                                                        載具隱碼
                                                        {isParamsErrorMap['carrierId2'] ? <span className="error-tip">請輸入載具隱碼</span> : null}
                                                    </h5>
                                                    <input
                                                        type="text"
                                                        value={carrierId2}
                                                        onChange={(event) => this.onInputChange('carrierId2', event)}
                                                    />
                                                </label>
                                            </div>
                                        }
                                    </div>
                                    :
                                    null
                                }

                                {isDonate ?
                                    <div>
                                        <div className="block-form-row">
                                            <label className="block-form-col">
                                                <h5 className="title">載具種類編號</h5>
                                                <div className="form-select">
                                                    <select value={carrierType} onChange={(event) => this.onInputChange('carrierType', event)}>
                                                        <option value={''}>
                                                            不使用
                                                        </option>
                                                        <option value={GLOBAL.CARRIER_TYPE.CITIZEN_CERT.value}>
                                                            {GLOBAL.CARRIER_TYPE.CITIZEN_CERT.label}
                                                        </option>
                                                        <option value={GLOBAL.CARRIER_TYPE.MOBILE.value}>
                                                            {GLOBAL.CARRIER_TYPE.MOBILE.label}
                                                        </option>
                                                    </select>
                                                    <div className="select-arrow"><i className="zmdi zmdi-caret-down"></i></div>
                                                </div>
                                            </label>
                                            <label 
                                                className={classNames("block-form-col", {
                                                   'error': isParamsErrorMap['loveCode']
                                                })}
                                            >
                                                <h5 className="title">
                                                    愛心碼
                                                    {isParamsErrorMap['loveCode'] ? <span className="error-tip">請輸入愛心碼</span> : null}
                                                </h5>
                                                <input
                                                    type="text"
                                                    value={loveCode}
                                                    onChange={(event) => this.onInputChange('loveCode', event)}
                                                />
                                            </label>
                                        </div>
                                        {!carrierType ?
                                            null
                                            :
                                            <div className="block-form-row">
                                                <label 
                                                    className={classNames("block-form-col", {
                                                       'error': isParamsErrorMap['carrierId1']
                                                    })}
                                                >
                                                    <h5 className="title">
                                                        載具明碼
                                                        {isParamsErrorMap['carrierId1'] ? <span className="error-tip">請輸入載具明碼</span> : null}
                                                    </h5>
                                                    <input
                                                        type="text"
                                                        value={carrierId1}
                                                        onChange={(event) => this.onInputChange('carrierId1', event)}
                                                    />
                                                </label>
                                                <label 
                                                    className={classNames("block-form-col", {
                                                       'error': isParamsErrorMap['carrierId2']
                                                    })}
                                                >
                                                    <h5 className="title">
                                                        載具隱碼
                                                        {isParamsErrorMap['carrierId2'] ? <span className="error-tip">請輸入載具隱碼</span> : null}
                                                    </h5>
                                                    <input
                                                        type="text"
                                                        value={carrierId2}
                                                        onChange={(event) => this.onInputChange('carrierId2', event)}
                                                    />
                                                </label>
                                            </div>
                                        }
                                    </div>
                                    :
                                    null
                                }
                            </div>
                            :
                            null
                        }

                        <div className="block-form">
                            <h3 className="block-title">商品資訊</h3>
                            <div className="block-form-wrapper">
                                {pdtlist.map((product, index) => {
                                    return (
                                        <div className="block-form-row" key={index}>
                                            {pdtlist.length > 1 ?
                                                <div 
                                                    className="delete-icon hint--left"
                                                    onClick={() => this.removeProduct(index)}
                                                    data-hint="刪除該商品"
                                                >
                                                    <i className="zmdi zmdi-delete"></i>
                                                </div>
                                                :
                                                null
                                            }
                                            <label 
                                                className={classNames("block-form-col", {
                                                   'error': product.isParamsErrorMap['pdtname']
                                                })}
                                            >
                                                <h5 className="title">
                                                    商品名稱
                                                    {product.isParamsErrorMap['pdtname'] ? <span className="error-tip">請輸入商品名稱</span> : null}
                                                </h5>
                                                <input
                                                    type="text"
                                                    value={product.pdtname}
                                                    onChange={(event) => this.onPdtlistInputChange(index, 'pdtname', event)}
                                                />
                                            </label>
                                            <label 
                                                className={classNames("block-form-col", {
                                                   'error': product.isParamsErrorMap['pdtid']
                                                })}
                                            >
                                                <h5 className="title">
                                                    商品編號
                                                    {product.isParamsErrorMap['pdtid'] ? <span className="error-tip">請輸入商品編號</span> : null}
                                                </h5>
                                                <input
                                                    type="text"
                                                    value={product.pdtid}
                                                    onChange={(event) => this.onPdtlistInputChange(index, 'pdtid', event)}
                                                />
                                            </label>
                                            <label 
                                                className={classNames("block-form-col", {
                                                   'error': product.isParamsErrorMap['pdtcount']
                                                })}
                                            >
                                                <h5 className="title">
                                                    商品數量
                                                    {product.isParamsErrorMap['pdtcount'] ? <span className="error-tip">請輸入正確的商品數量</span> : null}
                                                </h5>
                                                <input
                                                    type="number"
                                                    value={product.pdtcount}
                                                    onChange={(event) => this.onPdtlistInputChange(index, 'pdtcount', event)}
                                                />
                                            </label>
                                            <label 
                                                className={classNames("block-form-col", {
                                                   'error': product.isParamsErrorMap['pdtprice']
                                                })}
                                            >
                                                <h5 className="title">
                                                    商品單價(未稅)
                                                    {product.isParamsErrorMap['pdtprice'] ? <span className="error-tip">請輸入正確的商品單價</span> : null}
                                                </h5>
                                                <input
                                                    type="number"
                                                    value={product.pdtprice}
                                                    onChange={(event) => this.onPdtlistInputChange(index, 'pdtprice', event)}
                                                />
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>

                            <div 
                                className="block-form-add"
                                onClick={() => this.expandPdtlist()}
                            >
                                <span className="plus-icon"><i className="zmdi zmdi-plus"></i></span>增加銷售明細
                            </div>
                        </div>
                    </div>
                    :
                    null
                }
            </div>
        );
    }
}

const mapStateToProps = function (state) {
    return {invoices: state.invoice.invoices};
};

const mapActionToProps = function (dispatch) {
    return {
        invoiceActions: bindActionCreators(actionCreators.invoiceActionCreators, dispatch),
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch)
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {withRef: true})(EditInvoiceView);


// WEBPACK FOOTER //
// ./src/components/invoice/EditInvoiceView.jsx